import { AiChatState } from "@intelligems/ig-types/schemas/ai/ai-chat-state";
import { aiApiClient } from "@src/api/ai-api";
import { aiExperimentAnalyticsV2Keys } from "@src/api/queryKeys";
import { useQuery } from "@tanstack/react-query";

interface UseGetExperimentAnalyticsChatSessionHistoryV2Options {
  sessionId: string | null | undefined;
  enabled?: boolean;
}

const getExperimentAnalyticsChatSessionHistoryV2 = async (
  sessionId: string
): Promise<AiChatState | null> => {
  const response = await aiApiClient.get<AiChatState | null>(
    `/chat-history/session/${sessionId}`
  );
  return response.data ?? null;
};

export const useGetExperimentAnalyticsChatSessionHistoryV2 = ({
  sessionId,
  enabled = true,
}: UseGetExperimentAnalyticsChatSessionHistoryV2Options) => {
  return useQuery<AiChatState | null, Error>({
    queryKey: aiExperimentAnalyticsV2Keys.chatSessionHistory(sessionId!),
    queryFn: async () => getExperimentAnalyticsChatSessionHistoryV2(sessionId!),
    enabled: enabled && !!sessionId,
  });
};
